export const isInvalid = (key, val, compareVal) => {
    //console.log( "-----", key, val );
    if (!val && key !== 'category') {
        return "Поле не може бути порожнім";
    }

    switch (key) {
        case "title":
            if (val.length > 50) {
                return "Не більше 50 символів";
            }

            return null;
        case "body":
            if (val.length > 20000) {
                return "Не більше 20000 символів";
            }

            return null;
        case "categories":
            if (!val || val.length === 0) {
                return "Оберіть категорію";
            }

            return null;
        case "email":
            if (!val.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
                return "Не вірно вказаний email";
            }
            if (val === compareVal) {
                return "Даний email вже зайнятий";
            }

            return null;
        case "phone":
            const onlyNum = val.replace(/\D/g, '');

            if (onlyNum.length !== 10) {
                return "телефон повинен бути формату: (ххх) ххх хх хх";
            }
            if (val === compareVal) {
                return "Даний телефон вже зайнятий";
            }

            return null;
        default:
            return null;
    }

};
